const WARNING_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 9v4"/><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"/><path d="M12 16h.01"/></svg>`;

export default class ReportIssueControl {
    constructor(options = {}) {
        this.onToggle = options.onToggle || (() => {});
        this.isActive = false;
    }

    onAdd() {
        this.container = document.createElement('div');
        this.container.classList.add('mapboxgl-ctrl', 'mapboxgl-ctrl-group', 'mapboxgl-ctrl-report-issue');

        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.title = 'Report Issue';
        this.button.innerHTML = WARNING_SVG;
        let suppressClick = false;
        const handleToggle = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.onToggle(!this.isActive);
        };
        this.button.addEventListener('touchend', (event) => {
            suppressClick = true;
            handleToggle(event);
            setTimeout(() => {
                suppressClick = false;
            }, 300);
        }, { passive: false });
        this.button.addEventListener('click', (event) => {
            if (suppressClick) {
                return;
            }
            handleToggle(event);
        });

        this.container.appendChild(this.button);
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
    }

    setActive(active) {
        this.isActive = active;
        this.button.classList.toggle('active', active);
    }

    setVisible(visible) {
        if (this.container) {
            this.container.style.display = visible ? '' : 'none';
        }
    }
}
